// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"dropdownPlain_dropdown_3SdcBrP","dropdownTrigger":"dropdownPlain_dropdownTrigger_1kjxW8q","dropdownIcon":"dropdownPlain_dropdownIcon_3bz7m0Q"};